import { winterEnrollment } from '../data/mock';

const DAY = 86400000;

// 'pre' before priority, 'priority' between priority & public, 'open' after public.
export const enrollmentPhase = (now = Date.now()) => {
  if (now < new Date(winterEnrollment.priorityOpens).getTime()) return 'pre';
  if (now < new Date(winterEnrollment.publicOpens).getTime()) return 'priority';
  return 'open';
};

// The Sunday before the 1st of a month (if the 1st is a Sunday, the Sunday prior).
const sundayBeforeFirst = (year, month) => {
  const first = new Date(year, month, 1);
  const back = first.getDay() === 0 ? 7 : first.getDay();
  return new Date(first.getTime() - back * DAY);
};

// Next monthly release date (First Splash calendar + Foundations enrollment) and the month it's for.
export const nextMonthlyRelease = (now = new Date()) => {
  const [fy, fm, fd] = winterEnrollment.firstMonthlyRelease.split('-').map(Number);
  const first = new Date(fy, fm - 1, fd).getTime();
  for (let i = 0; i <= 24; i += 1) {
    const target = new Date(now.getFullYear(), now.getMonth() + i, 1);
    const release = sundayBeforeFirst(target.getFullYear(), target.getMonth());
    if (release.getTime() >= first && release.getTime() + DAY > now.getTime()) {
      return { release, forMonth: target.toLocaleDateString('en-US', { month: 'short', year: 'numeric' }) };
    }
  }
  return null;
};

export const fmtDate = (d) => d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
